import React, { FC } from 'react';
import { writeText } from 'clipboard-polyfill/text';
import { useSelector } from 'react-redux';

import { UiButton } from 'src/components/UI/Button';
import { UiCleanWYSIWYG } from 'src/components/UI/CleanWYSIWYG';
import { UiModal } from 'src/components/UI/modal/UiModal';
import { UiOuterLink } from 'src/components/UI/OuterLink';
import { dispatchOverlayShareHide } from 'src/store/commonPart';
import { deCommonCurrentPartnerSelector } from 'src/store/commonPart/selector';
import { useTHelper } from 'src/utils/i18n';
import { useStateForm } from 'src/utils/stateForm';
import { UiToast } from 'src/components/UI/toasts';

type Props = {
  text: string;

  showReferralText?: boolean;
  sharingEmailTemplate?: string;

  textToGiveKeyword?: string;

  onClose?: () => void;
};

type FormValues = {
  sharingEmailTemplate: string;
};

/** ShareWithOthersBodyTemplate.cshtml */
export const OverlayShareLink: FC<Props> = ({
  text,
  showReferralText,
  sharingEmailTemplate,
  textToGiveKeyword,
  onClose,
}) => {
  const tHelper = useTHelper('common.copyLinkModal');

  const formProps = useStateForm<FormValues>({
    defaultValues: {
      sharingEmailTemplate,
    },
  });

  const { TwilioDisplayedString } = useSelector(deCommonCurrentPartnerSelector);

  return (
    <UiModal
      modalClassName="share-with-others-modal"
      header={tHelper('header')}
      onlySuccessBtn
      successBtnText={tHelper('closeBtnText')}
      successBtnClassProperty="secondaryBordered"
      onHide={onClose || dispatchOverlayShareHide}
    >
      <div className="share-modal-wrapper">
        <p className="no-margin">{tHelper('title')}</p>

        <div className="row">
          <div className="col-xs-12 col-sm-8">
            <UiOuterLink href={text} className="referral-url-link HeaderTextColor">
              {text}
            </UiOuterLink>
          </div>
          <div className="col-xs-12 col-sm-4">
            <UiButton
              effects
              primary
              className="btn btn-primary no-margin btn-action-rounded text-transform-none"
              onClick={() => {
                writeText(text);
                UiToast.success(tHelper('toast'));
              }}
            >
              {tHelper('copyLink')}
            </UiButton>
          </div>
        </div>

        {showReferralText && (
          <div className="row margin-top-20">
            <div className="col-xs-12">
              <p>{tHelper('suggestedMessage')}</p>
            </div>
            <div className="col-xs-12 margin-bottom-20">
              <UiCleanWYSIWYG formProps={formProps} name="sharingEmailTemplate" />
            </div>
            <div className="col-xs-12 text-center">
              <UiButton
                primary
                primaryNew
                effects
                className="no-margin"
                onClick={() => {
                  const div = document.createElement('div');
                  div.innerHTML = formProps.getValue('sharingEmailTemplate');
                  const text = div.textContent || div.innerText || '';

                  writeText(text);
                }}
              >
                {tHelper('copy')}
              </UiButton>
            </div>
          </div>
        )}

        {textToGiveKeyword && (
          <div className="row">
            <div className="col-xs-12">
              <span className="message">
                {tHelper('textToGivemessage', {
                  textToGiveKeyword,
                  TwilioDisplayedString: TwilioDisplayedString || '',
                })}
              </span>
            </div>
          </div>
        )}
      </div>
    </UiModal>
  );
};
